
import { useRequest } from "ahooks"
import { Form, Input, Modal, ModalProps, Select } from "antd"
import { useEffect, useMemo, useState } from "react"
import { createRoot } from "react-dom/client"
import { EquipmentMenu, createEquipmentMenus, updateEquipmentMenus, OrganizationEquipmentMenuService } from "@/services/admin/equipment-menu/equipmentMenu.services"
import { Equipment } from "@/services/project/equipment/equipment.model"
import { getProjectEquipments, OrganizationEquipmentService } from "@/services/project/equipment/equipment.service"

interface CreateMenuProps extends ModalProps {
  menu?: EquipmentMenu
  onSuccess?: () => void
  orgId?: number
}

export function CreateEditMenu(props: CreateMenuProps) {
  const { onSuccess, onCancel, menu, orgId } = props
  const [form] = Form.useForm()
  const [equipments, setEquipments] = useState<Equipment.Base[]>([])

  useEffect(() => {
    const fetchEquipments = async () => {
      if (orgId) {
        const data = await OrganizationEquipmentService.getEquipments(orgId)
        setEquipments(data)
      } else {
        const data = await getProjectEquipments()
        setEquipments(data)
      }
    }
    fetchEquipments()
  }, [orgId])

  const equipmentOptions = useMemo(() => {
    if (equipments.length === 0) return []
    return equipments
      .map(item => ({ value: item.id, label: item.name}))
  }, [equipments])

  useEffect(() => {
    if (menu) {
      const values = {
        name: menu.name,
        equipment: menu.equipment.map(item => item.id)
      }
      form.setFieldsValue(values)
    }
  }, [menu])

  const { loading, run } = useRequest(
    (values) => {
      if (orgId) {
        if (menu) {
          return OrganizationEquipmentMenuService.updateEquipmentMenus(menu.id, values)
        }
        return OrganizationEquipmentMenuService.createEquipmentMenus(orgId, values)
      }
      if (menu) {
        return updateEquipmentMenus(menu.id, values)
      }
      return createEquipmentMenus(values)
    },
    {
      manual: true,
      onSuccess: () => {
        handleCancel()
        onSuccess?.()
      }
    }
  )

  const handleCancel = (e?) => {
    onCancel?.(e)
  }


  return <Modal
    {...props}
    width={600}
    maskClosable={false}
    open
    onCancel={handleCancel}
    onOk={() => form.submit()}
  >
    <div>{ menu ? 'Edit' : 'Create'} Palette Container</div>
    <Form
      form={form}
      onFinish={(values) => {
        run(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter  name' }]}>
        <Input type='text' />
      </Form.Item>

      <Form.Item label='Equipment' name='equipment' rules={[{ required: true, message: 'Please select equipment' }]}>
        <Select options={equipmentOptions} mode="multiple"/>
      </Form.Item>
    </Form>
  </Modal>
}

CreateEditMenu.show = (props: CreateMenuProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div); // createRoot(container!) if you use TypeScript
  root.render(<CreateEditMenu
    {...props}
    onCancel={(e) => {
      props.onCancel?.(e)
      root.unmount()
    }}
  />);
}